var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSynergiesBulkUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#323130",
    d: "M.5.5h15v15H.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#323130",
    d: "M.5.5h15v3H.5zM.5 3.5h5v4h-5zM.5 11.5h5v4h-5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#323130",
    d: "M.5 3.5h5v12h-5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.646 9.146a.5.5 0 000 .708l3.182 3.182a.5.5 0 10.708-.708L8.707 9.5l2.829-2.828a.5.5 0 10-.708-.708L7.646 9.146zM14 9H8v1h6V9z",
    fill: "#000"
  })));
}

export default SvgSynergiesBulkUpload;